import React from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in" onClick={onClose} data-id="element-159">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-hidden flex flex-col animate-scale-in" onClick={e => e.stopPropagation()} data-id="element-160">
        <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-161">
          <h3 className="text-lg font-bold text-[#111827] font-['Montserrat']" data-id="element-162">
            {title}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-163">
            <X size={20} className="text-gray-500" data-id="element-164" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-sm text-gray-600 space-y-4 font-['Poppins']" data-id="element-165">
          {content}
        </div>
      </div>
    </div>;
}